
import { defineComponent } from 'vue'
import { useStore } from 'vuex'
import TileButtons from '@/components/block/TileButtons.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import SimpleLinkList from '@/components/block/SimpleLinkList.vue'

export default defineComponent({
  name: 'MypageContents',

  components: {
    TileButtons,
    SimpleLinkList,
    HeadingLv3
  },

  setup() {
    const store = useStore()
    const userInfo = store.state.userInfo

    const buttonItems = [
      {
        icon: 'heart',
        label: 'お気に入り病院一覧',
        link: '/mypage/bookmark/list',
        badgeNum:
          userInfo.favorite_history.length + userInfo.s_favorite_history.length
      },
      {
        icon: 'document',
        label: '資料請求一覧',
        link: '/mypage/document_request/list',
        badgeNum:
          userInfo.request_history.length + userInfo.s_request_history.length
      },
      {
        icon: 'hospital-02',
        label: '病院見学一覧',
        link: '/mypage/visit_application/list',
        badgeNum:
          userInfo.inspection_history.length +
          userInfo.s_inspection_history.length
      },
      {
        icon: 'calendar',
        label: '申込イベント一覧',
        link: '/mypage/event/list',
        badgeNum: userInfo.event_history ? userInfo.event_history.length : 0
      }
    ]

    const kihon = [
      {
        heading: '登録情報の確認・変更',
        link: '/mypage/user/profile',
        label: userInfo.required_flg ? '' : '未設定項目あり'
      },
      {
        heading: '保存した検索条件',
        link: '/mypage/saved_search_conditions/list',
        label: ''
      }
      // {
      //   heading: 'パスワード変更',
      //   link: '',
      //   label: ''
      // }
      // {
      //   heading: '登録情報',
      //   link: '',
      //   label: ''
      // }
    ]

    const others = [
      {
        heading: 'お問い合わせ',
        link: '/contact/input',
        label: ''
      },
      {
        heading: 'ログアウト',
        link: '/logout',
        label: ''
      }
      // {
      //   heading: '退会',
      //   link: '',
      //   label: ''
      // }
    ]
    return {
      buttonItems,
      kihon,
      others
    }
  }
})
